import React, { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, CircularProgress, List, ListItem, ListItemButton, ListItemText, Checkbox,
} from '@mui/material'
import { bulkSharePortfolioFilesToBps } from 'services/portfolioDocumentsService'
import { toast } from 'react-toastify'

const ORANGE = '#D24724'

export default function BulkShareToBpsModal({ portfolioId, fileIds, buildingPassports = [], onShared, onClose }) {
  const [selected, setSelected] = useState({})
  const [busy, setBusy] = useState(false)

  const toggle = (id) => setSelected((s) => ({ ...s, [id]: !s[id] }))
  const chosen = Object.keys(selected).filter((id) => selected[id])

  const submit = async () => {
    if (chosen.length === 0) { toast.error('Select at least one Building Passport'); return }
    setBusy(true)
    try {
      const { data } = await bulkSharePortfolioFilesToBps(portfolioId, fileIds, chosen)
      const copies = data.data?.copies ?? 0
      toast.success(`Added ${fileIds.length} document${fileIds.length === 1 ? '' : 's'} to ${chosen.length} Building Passport${chosen.length === 1 ? '' : 's'} (${copies} cop${copies === 1 ? 'y' : 'ies'})`)
      onShared && onShared()
      onClose()
    } catch (e) {
      toast.error(e.response?.data?.message || 'Failed to add to Building Passports')
    } finally { setBusy(false) }
  }

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add {fileIds.length} document{fileIds.length === 1 ? '' : 's'} to Building Passports</DialogTitle>
      <DialogContent dividers>
        <p style={{ marginTop: 0, color: '#666', fontSize: 14 }}>
          A copy of each selected document will be added to every chosen Building Passport's files.
        </p>
        {buildingPassports.length === 0 ? (
          <p style={{ color: '#888' }}>You don't have access to any Building Passports in this portfolio.</p>
        ) : (
          <List dense sx={{ maxHeight: 320, overflow: 'auto' }}>
            {buildingPassports.map((bp) => (
              <ListItem key={bp.id} disablePadding>
                <ListItemButton onClick={() => toggle(bp.id)} dense>
                  <Checkbox edge="start" checked={!!selected[bp.id]} tabIndex={-1} disableRipple
                    sx={{ '&.Mui-checked': { color: ORANGE } }} />
                  <ListItemText primary={bp.name || bp.address || 'Building Passport'} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {buildingPassports.length > 0 && (
          <Button variant="contained" onClick={submit} disabled={busy || chosen.length === 0}
            sx={{ backgroundColor: ORANGE, '&:hover': { backgroundColor: '#bd3f20' } }}>
            {busy ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : `Add to ${chosen.length || ''} Building Passport${chosen.length === 1 ? '' : 's'}`.trim()}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
